import styled from 'styled-components';

import themeSpacing from '@polyai/ui/styles/config/spacing';

import { TwilioInboundSipCard } from 'components/molecules/AddNumberModal';

export const TwilioSipCard = styled(TwilioInboundSipCard)`
  margin: ${themeSpacing.sm4} 0;
`;
